import { actionCreator, reducedStream, reducer } from '@ardoq/rxbeach';

export const readerCaptureModeChanged = actionCreator<boolean>(
  '[pptxExport] Reader capture mode changed'
);

const toCaptureMode = (_state: boolean, isCaptureMode: boolean): boolean =>
  isCaptureMode;

export const readerCaptureMode$ = reducedStream('readerCaptureMode$', false, [
  reducer(readerCaptureModeChanged, toCaptureMode),
]);
